// extracted by mini-css-extract-plugin
module.exports = {"modal":"index_modal__GwwU0","inMobile":"index_inMobile__VXMw9"};